
export const routes = [
  { path: '/', redirect: '/dashboard' },
  {
    path: '/',
    component: () => import('@/layouts/default.vue'),
    meta: { requiresAuth: true },
    children: [

      // analitycs
      {
        path: 'marcacion',
        component: () => import('@/pages/marcacion.vue'),
        meta: { viewKey: 'marcacion' },
      },

      // Dashboard es la vista de aterrizaje: no se gatea (el guard redirige aquí).
      { path: 'dashboard', component: () => import('@/pages/dashboard.vue') },


      // personal data
      { path: 'viatics', component: () => import('@/pages/viatics.vue'), meta: { viewKey: 'viatics' } },
      { path: 'myviatics', component: () => import('@/pages/myviatics.vue'), meta: { viewKey: 'myviatics' } },

      // gestion del sistema
      { path: 'list-users', component: () => import('@/pages/list-users.vue'), meta: { viewKey: 'list-users' } },


      // configuracion del sistema
      { path: 'config-doc', component: () => import('@/pages/config-system.vue'), meta: { viewKey: 'config-doc' } },
      { path: 'proyect', component: () => import('@/pages/list-client-proyect.vue'), meta: { viewKey: 'proyect' } },
      { path: 'company-info', component: () => import('@/pages/view.companySettings.vue'), meta: { viewKey: 'company-info' } },
      { path: 'platform', component: () => import('@/pages/view.platformSettings.vue'), meta: { viewKey: 'platform' } },

    ],
  },
  {
    path: '/',
    component: () => import('@/layouts/blank.vue'),
    children: [
      {
        path: 'login',
        component: () => import('@/pages/login.vue'),
        meta: { requiresGuest: true },
      },
      {
        path: 'register',
        component: () => import('@/pages/register.vue'),
      },
      {
        path: 'reset-password',
        component: () => import('@/pages/reset-password.vue'),
      },
      {
        path: '/:pathMatch(.*)*',
        component: () => import('@/pages/[...error].vue'),
      },
    ],
  },
]
